import type { StaffRole, User } from '../../types/user';

/** The roles that look after what the crag says about itself. */
const ROLES: StaffRole[] = ['admin', 'editor'];

/**
 * Whether `user` may prepare a crag's printable sheet: a confirmed admin or
 * editor of it — the people who already write its description and its routes.
 *
 * One rule for the page and for the button that leads to it, so the button is
 * never offered to somebody the page would turn away. The sheet is made of
 * what the crag page shows anyone, so nothing on the server needs guarding.
 */
export function canPrintCragSheet(user: Pick<User, 'staff'> | null | undefined, cragSlug: string) {
  const staff = user?.staff?.find((entry) => entry.gym_slug === cragSlug);
  return staff?.status === 'confirmed' && staff.staff_roles.some((role) => ROLES.includes(role));
}
